import React, { useEffect, useState } from "react";
import { baseRequest } from "../../../axiosconfig";

function ArchivePoslovniProcesi(props) {
  const [lists, setLists] = useState([]);
  const [loaded, setLoaded] = useState(false);

  const headerTitles = [
    { id: 0, title: "Šifra", width: "10%" },
    { id: 1, title: "Naziv procesa", width: "30%" },
    { id: 2, title: "Vlasnici", width: "35%" },
    { id: 3, title: "Datum izmene", width: "17%" },
    { id: 4, title: "", width: "8%" },
  ];

  useEffect(() => {
    baseRequest
      .get("/business_processes")
      .then((res) => {
        const all = res.data.business_processes || [];
        const archivedLists = [];
        for (const bp of all) {
          if (!bp.is_archived) continue;
          for (const bpl of bp.business_process_lists || []) {
            archivedLists.push({
              id: bpl.id,
              code: bpl.code,
              name: bpl.name,
              updated_at: bpl.updated_at,
              owners: (bpl.business_process_owners || [])
                .map((o) => `${o.first_name || ""} ${o.last_name || ""}`.trim())
                .filter(Boolean)
                .join(", "),
            });
          }
        }
        setLists(archivedLists);
        setLoaded(true);
      })
      .catch(() => setLoaded(true));
  }, []);

  return (
    <div>
      <ul
        className="registri-header"
        style={{
          borderLeft: "var(--mainBorder)",
          borderRight: "var(--mainBorder)",
          borderBottom: "var(--mainBorder)",
        }}
      >
        {headerTitles.map((item) => (
          <li
            key={item.id}
            className="registri-header-cell"
            style={{ width: item.width }}
          >
            {item.title}
          </li>
        ))}
      </ul>
      {loaded && lists.length === 0 && (
        <div
          style={{
            padding: "40px",
            textAlign: "center",
            color: "var(--mainColor)",
          }}
        >
          Nema arhiviranih listi poslovnih procesa.
        </div>
      )}
      {lists.map((item) => (
        <ul
          key={item.id}
          className="registri-header"
          style={{
            borderLeft: "var(--mainBorder)",
            borderRight: "var(--mainBorder)",
            borderBottom: "var(--mainBorder)",
          }}
        >
          <li className="registri-header-cell" style={{ width: "10%" }}>
            {item.code || ""}
          </li>
          <li className="registri-header-cell" style={{ width: "30%" }}>
            {item.name || ""}
          </li>
          <li className="registri-header-cell" style={{ width: "35%" }}>
            {item.owners || ""}
          </li>
          <li className="registri-header-cell" style={{ width: "17%" }}>
            {item.updated_at ? item.updated_at.slice(0, 10) : ""}
          </li>
          <li className="registri-header-cell" style={{ width: "8%" }}></li>
        </ul>
      ))}
    </div>
  );
}

export default ArchivePoslovniProcesi;
